import type { FleetVehicle } from '@/lib/api/fleet-api'
import { isFleetOffline } from '@/lib/fleet-format'

// motion_status: 0=chạy, 1=dừng, 2=mất tín hiệu. Xe offline (mất tín hiệu / chưa
// cấu hình / disabled) coi như -1 để không lẫn với "đang chạy".
export function motionStatusOf(v: FleetVehicle): number {
    if (isFleetOffline(v) || !v.gps) return -1
    return v.gps.motion_status
}

export function selectMoving(vehicles: FleetVehicle[]): FleetVehicle[] {
    return vehicles.filter((v) => motionStatusOf(v) === 0)
}

// Xe chuyển từ trạng thái != 0 (ở poll trước) sang 0 (poll này). Xe chưa từng
// thấy ở poll trước bị bỏ qua — mới vào tầm phủ sóng không phải "khởi hành".
export function detectDepartures(
    prev: Map<string, number>,
    curr: FleetVehicle[],
): string[] {
    const out: string[] = []
    for (const v of curr) {
        if (motionStatusOf(v) !== 0) continue
        const before = prev.get(v.vehicle_id)
        if (before !== undefined && before !== 0) out.push(v.vehicle_id)
    }
    return out
}

export function sortByMovingSince(
    moving: FleetVehicle[],
    movingSince: Map<string, number>,
): FleetVehicle[] {
    return [...moving].sort(
        (a, b) =>
            (movingSince.get(b.vehicle_id) ?? 0) -
            (movingSince.get(a.vehicle_id) ?? 0),
    )
}

export function nextInRotation(
    orderedIds: string[],
    currentId: string | null,
): string | null {
    if (orderedIds.length === 0) return null
    const idx = currentId ? orderedIds.indexOf(currentId) : -1
    return orderedIds[(idx + 1) % orderedIds.length]
}
